import React, { createContext, useContext, useState, useCallback } from "react";
import { api, saveSession, clearSession, getSession } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [session, setSession] = useState(() => getSession());

  const login = useCallback(async (callsign, password) => {
    const data = await api.login(callsign, password);
    saveSession(data.token, data.user);
    setSession({ token: data.token, user: data.user });
    return data;
  }, []);

  const logout = useCallback(() => {
    clearSession();
    setSession(null);
  }, []);

  return (
    <AuthContext.Provider value={{ session, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth debe usarse dentro de <AuthProvider>");
  return ctx;
}
